<template>
  <ion-page id="sendemailverify-page">
    <ion-content>
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" :style="styleOneFrame" :key="menuTrigger">
  
        <ion-item>
          <h5>{{ note }}</h5>
        </ion-item>
        <ion-item>
          <h5>{{ message1 }}</h5>
        </ion-item>

       <ion-item>
          <ion-input :label="codeString" label-placement="fixed" 
                    :placeholder="enterCodeString" :value="code"
                    @ionInput="codeInputChange">
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-button size="large" @click="doSendVerifyEmail()" :disabled="wasSent" >{{ t("Send Verification Email") }}</ion-button>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <ion-button :disabled="code.length != 6 || goodCode" size="large" @click="doCheckCode()" >{{ t("Check Code") }}</ion-button>
        </ion-item>

      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>

import { IonLabel,IonCheckbox, IonGrid,IonRow,IonCol,IonButton,IonItem,IonInput,IonPage, IonContent , modalController } from '@ionic/vue';

import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
import { t } from '@/composables/translateText.js'

import { ref, watch } from 'vue';
import { useGetData } from '@/composables/getData.js'
import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';
import { doStartupCheck } from '@/composables/startupCheck.js'
import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight }  from '@/composables/screenSize'

const connectionStore = useConnectionStore()

const isDark = ref(connectionStore.getDarkmode != "" && connectionStore.getDarkmode != "light")
const menuTrigger = ref(0)

const windowSizeStore = useWindowSizeStore()
const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] })

const codeString = ref(t("Code"))
const enterCodeString = ref(t("Enter code"))
const code = ref("")
const message1 = ref("")

const wasSent = ref(false)
const goodCode = ref(false)

const note = ref(t("To verify your email, click the send button below. You'll receive a 6 digit code to enter on the next line"))

 const styleOneFrame = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

updateWidthHeights()

const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** logoff new window size",windowSizeRef.value)
    menuTrigger.value++
    updateWidthHeights()
  })

function updateWidthHeights() {
   const availableSpace = availableWidthHeight()
    const subscribePositionTop = availableSpace.topIndent
    const subscribePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
    const subscribeHeight = availableSpace.height - subscribePositionTop + availableSpace.topIndent
    const subscribeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    styleOneFrame.value.height = subscribeHeight + "px"
    styleOneFrame.value.width = subscribeWidth + "px"
    styleOneFrame.value.top = subscribePositionTop + "px"
    styleOneFrame.value.left = subscribePositionLeft + "px"
}

function codeInputChange(ev) {
    //console.log("email ",ev)
    const value = ev.target.value;
    ///console.log("code",value)
    code.value = value.trim()
  }

function doSendVerifyEmail () {
  message1.value = t("Sending Verification Email") + "..."
  var formData = { junk : "blah" }
  useGetData("chessvis_email_verification.php", formData, processJsonResponse)
}

function processJsonResponse (json) {
  //console.log(" in email verification callback",json)
  if (json.hasOwnProperty('error')) {
    openErrorModal(json['programRun'],json['error'])
    return;
  }

  message1.value = t(json['mess'])
  wasSent.value = true
}

function doCheckCode() {
  message1.value = t("Checking code") + "..."
  var formData = { 
    code : code.value
  }
  //console.log(formData)
  useGetData("chessvis_email_verify_check.php", formData, processCheckJsonResponse)
}

function processCheckJsonResponse (json) {
  //console.log(" in email verification callback",json)
  if (json.hasOwnProperty('error')) {
    openErrorModal(json['programRun'],json['error'])
    return;
  }

  const response = json['stat']
  if (response == "match") {
    message1.value = t("Email Verified.")
    connectionStore.setEmailVerified("yes")
    goodCode.value = true
  }
  else {
    message1.value = t("Code doesn't match. Please try again")
    goodCode.value = false
  }
}

</script>

<style scoped>

.item{
  margin:10px auto;
}

</style>